<template>
  <div class="check-work-body">
    <div>
      <div class="search-wrap">
        <el-button size="mini" type="primary" @click="edit()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>

        <el-input size="mini" placeholder="请输入类型名称" v-model="where.name" clearable style="width: 200px"></el-input>


        <el-button size="mini" type="primary" @click="search">搜索</el-button>

        <div style="width: 30px;display: inline-block;"></div>

        <el-button type="danger" size="mini" icon="el-icon-delete" v-if="multipleSelection.length" @click="dels()">删除</el-button>

      </div>

      <div class="table-wrap">
        <el-table v-if="pageData" border v-loading="loading" :data="pageData.list" @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column prop="id" label="id" align="center" width="50"></el-table-column>
          <el-table-column prop="name" label="	类型名称" align="center" width="200"></el-table-column>
          <el-table-column prop="xsc_number" label="新视窗ID" align="center"></el-table-column>
          <el-table-column prop="admin_name" label="操作人" align="center" width="100"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" align="center" width="100"></el-table-column>
          <el-table-column prop="update_time" label="操作时间" align="center" width="80"></el-table-column>
          <el-table-column label="操作 " align="center" width="220">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="edit(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
      </div>
    </div>



    <!-- 修改窗口 -->
    <el-dialog title="编辑" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="票据类型名称" prop="title">
            <el-input class="form-input" v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="新视窗ID" prop="title">
            <el-input class="form-input" v-model="form.xsc_number" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="备注" prop="title">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="form.remarks"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>

        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button :disabled="form.status>1" type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

export default {
  name:"OrderBillType",
  data () {
    return {
      host_url:"",
      keyword: '',
      loading: false,
      where:{
        name:""
      },
      pageData:{
        list:[],
        total:0,
        pageSize:15,
        page:1
      },
      dialogVisible:false,
      form:{
        name:"",
        xsc_number:"",
        remarks:"",
      },
      uploadUrl:"",
      month_value:"",
      business_list:[],
      entry_type_name:"",
      multipleSelection:[],
    }
  },
  created() {
    this.host_url=__HTTP__.defaults.baseURL;
    // this.month_value=CommonHelp.date("YYYY-MM");
    this.getList()
  },
  activated() {
    this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },

  },
  computed:{

  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        name:"",
        xsc_number:"",
        remarks:"",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      let where=reObject(this.where);
      ERP.getRequest({
        url:"admin/OrderBillType/getList",
        data:{
          where:JSON.stringify(where),
          page: this.pageData.page,
          page_size: this.pageData.pageSize
        }
      },res=>{
        if(res.code) {
          res.data.list.map(ret=>{

            // ret.is_invoice=ret.is_invoice === 1;
            // ret.is_paid=ret.is_paid === 1;
            return ret;
          })
          that.pageData=res.data
        }
        that.loading=false;
        that.multipleSelection=[]
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    edit(item) {
      if(!item) {
        this.form = this.getFormData({})
      } else {
        let data=reObject(item)
        data.bill_type&&(data.bill_type=data.bill_type.split(","))
        this.form = data;
      }
      this.dialogVisible = true
    },

    submitForm(formName) {
      var that=this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.formLoading = true
          let data = Object.assign({}, this.form)

          ERP.postRequest({url:"admin/OrderBillType/save", data:data},res => {
            that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              that.dialogVisible = false
              that.getList()
            }
            that.formLoading = false
          })
        } else {
          return false;
        }
      });
    },

    setFrom(data){
      var that=this;
      ERP.postRequest({url:"admin/OrderBillType/save", data:data},res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    del(item){
      var that=this;
      ERP.postRequest({
        url:"admin/OrderBillType/delete",
        data:{
          id:item.id
        }
      },res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    dels(){
      var that=this;
      ERP.postRequest({
        url:"admin/OrderBillType/delete",
        data:{
          ids:this.multipleSelection.map(ret=>{return ret.id}).join(',')
        }
      },res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
  }
}
function reObject(item){
  return JSON.parse(JSON.stringify(item));
}
</script>
<style lang="scss" scoped>

.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}


.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  // border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td, th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}


.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 230px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/OrderBillType.vue